import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77ef4de3"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "confirmModal",
  tabindex: "-1",
  "aria-labelledby": "confirmModalLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title",
  id: "confirmModalLabel"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1 /* HOISTED */))
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "modal-footer" }
const _hoisted_9 = {
  type: "button",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString($props.title), 1 /* TEXT */),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("p", null, _toDisplayString($props.message), 1 /* TEXT */)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", _hoisted_9, _toDisplayString($setup.lms_website.__('Cancel')), 1 /* TEXT */),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            onClick: _cache[0] || (_cache[0] = (...args) => ($options.confirm && $options.confirm(...args)))
          }, _toDisplayString($setup.lms_website.__('Confirm')), 1 /* TEXT */)
        ])
      ])
    ])
  ]))
}